import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { SignupCard } from './SignupCard';
import { SignupAudience } from '../../types/signup';
interface LandingHeroProps {
  audience: SignupAudience;
  onAudienceChange: (a: SignupAudience) => void;
}
const ease = [0.23, 1, 0.32, 1] as const;
const facts = [{
  value: '150+',
  label: 'countries'
}, {
  value: '$5–$20',
  label: 'per gig'
}, {
  value: '24h',
  label: 'payouts'
}];
export function LandingHero({
  audience,
  onAudienceChange
}: LandingHeroProps) {
  const reduce = useReducedMotion();
  const enter = (delay: number) => reduce ? {} : {
    initial: {
      opacity: 0,
      y: 16
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.3,
      ease,
      delay
    }
  };
  return <section className="mx-auto grid max-w-6xl items-center gap-12 px-6 pb-20 pt-12 md:pt-20 lg:grid-cols-[1.05fr_1fr] lg:gap-16" data-id="element-120" data-mp="3fy5okklwcnls">
      <div data-id="element-121" data-mp="24ktrqtok1594">
        <motion.p className="flex items-center gap-2 font-mono text-xs text-muted" {...enter(0)} data-id="element-122" data-mp="24klhzanqag25">
          <span className="relative flex h-2 w-2" data-id="element-123" data-mp="2ycnth0qb9hwz">
            {!reduce && <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent opacity-60" data-id="element-124" data-mp="2yf1pbbstey5l" />}
            <span className="relative inline-flex h-2 w-2 rounded-full bg-accent" data-id="element-125" data-mp="2tg74y5f791jd" />
          </span>
          early access is open
        </motion.p>

        <h1 className="mt-6 font-display text-5xl font-semibold leading-[1.02] tracking-tight md:text-6xl lg:text-7xl" data-id="element-126" data-mp="32dhmu9mivox9">
          {['Real', 'humans,', 'on', 'the', 'ground,'].map((word, i) => <motion.span key={word} className="mr-[0.22em] inline-block" {...enter(0.05 + i * 0.04)} data-id="element-127" data-mp="3cbnmslorqkzh" data-mpi={i}>
              {word}
            </motion.span>)}
          <motion.span className="inline-block text-accent" {...enter(0.26)} data-id="element-128" data-mp="3m2ialuhnxsn1">
            in any city.
          </motion.span>
        </h1>

        <motion.p className="mt-6 max-w-lg text-lg leading-relaxed text-muted" {...enter(0.3)} data-id="element-129" data-mp="3xopngq28tke">
          LocalTask connects companies with verified locals for quick in-person tasks: testing payments, checking stores,
          running errands. We're launching soon. Grab your spot.
        </motion.p>

        <motion.dl className="mt-10 flex flex-wrap gap-x-10 gap-y-4" {...enter(0.36)} data-id="element-130" data-mp="2ws6toir1ggd6">
          {facts.map(f => <div key={f.label} data-id="element-131" data-mp="31p5luvr56d8q">
              <dt className="sr-only" data-id="element-132" data-mp="36h6ve9wxdpv2">{f.label}</dt>
              <dd data-id="element-133" data-mp="36irodv3ld0qt">
                <span className="block font-display text-3xl font-semibold tracking-tight" data-id="element-134" data-mp="36j9rnboo8f88">{f.value}</span>
                <span className="font-mono text-xs text-muted" data-id="element-135" data-mp="3bime3vbmrkaa">{f.label}</span>
              </dd>
            </div>)}
        </motion.dl>
      </div>

      <motion.div initial={reduce ? false : {
      opacity: 0,
      y: 20,
      scale: 0.98
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} transition={{
      duration: 0.3,
      ease,
      delay: 0.15
    }} data-id="element-136" data-mp="3ki112ksl9cq1">
        <SignupCard audience={audience} onAudienceChange={onAudienceChange} data-id="element-137" data-mp="1q48i80ogkb5d" />
      </motion.div>
    </section>;
}